import React, { useState } from 'react';
import api from '../api/client';

export default function ExportButtons({ params = {}, onPrint }) {
  const [loading, setLoading] = useState('');

  const download = async (type) => {
    setLoading(type);
    try {
      const resp = await api.get(`/reports/export/${type}`, {
        params,
        responseType: 'blob',
      });
      const mime = type === 'excel'
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : 'application/pdf';
      const ext  = type === 'excel' ? 'xlsx' : 'pdf';
      const url  = URL.createObjectURL(new Blob([resp.data], { type: mime }));
      const a    = document.createElement('a');
      a.href     = url;
      a.download = `AVM-Rapor-${params.start||''}${params.end ? '-'+params.end : ''}.${ext}`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      alert('Export başarısız: ' + (err.response?.data?.message || err.message));
    } finally { setLoading(''); }
  };

  return (
    <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
      <button
        className="btn btn-secondary btn-sm"
        onClick={() => download('excel')}
        disabled={!!loading}
        title="Excel olarak indir"
      >
        {loading==='excel' ? <span className="spinner" style={{width:13,height:13}} /> : '📊'}
        Excel
      </button>
      <button
        className="btn btn-secondary btn-sm"
        onClick={() => download('pdf')}
        disabled={!!loading}
        title="PDF olarak indir"
      >
        {loading==='pdf' ? <span className="spinner" style={{width:13,height:13}} /> : '📄'}
        PDF
      </button>
      <button
        className="btn btn-secondary btn-sm"
        onClick={onPrint || (() => window.print())}
        disabled={!!loading}
        title="Yazdır"
      >
        🖨️ Yazdır
      </button>
    </div>
  );
}
